import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative h-[620px] md:h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Elegant%20artistic%20portrait%20photography%20studio%20atmosphere%2C%20soft%20dramatic%20lighting%2C%20professional%20camera%20equipment%20silhouette%2C%20warm%20golden%20and%20cream%20tones%2C%20minimalist%20dark%20moody%20background%20with%20soft%20bokeh%2C%20cinematic%20atmosphere%2C%20luxury%20aesthetic&width=1600&height=900&seq=hero-main-01&orientation=landscape"
          alt="秀人写真 - 专业人像摄影定制服务"
          className="w-full h-full object-cover"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60"></div>
      <div className="relative z-10 w-full text-center px-6">
        <p className="text-white/70 text-sm md:text-base tracking-widest mb-4 font-label">
          XIUREN PHOTOGRAPHY
        </p>
        <h1 className="text-3xl md:text-5xl lg:text-6xl text-white font-heading leading-tight mb-5 max-w-3xl mx-auto">
          定格你的<strong className="font-heading">独家瞬间</strong>
        </h1>
        <p className="text-white/75 text-sm md:text-base max-w-xl mx-auto mb-8 leading-relaxed">
          专业摄影师团队 · 精修后期处理 · 多元风格选择<br />
          用心记录每一个值得珍藏的美好时刻
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="#contact"
            className="whitespace-nowrap px-8 py-3 rounded-full bg-primary-500 text-white text-sm font-medium hover:bg-primary-600 transition-all cursor-pointer"
          >
            立即预约拍摄
          </a>
          <Link
            to="/category"
            className="whitespace-nowrap px-8 py-3 rounded-full border border-white/30 text-white text-sm font-medium hover:bg-white/10 transition-all cursor-pointer"
          >
            浏览作品集
          </Link>
        </div>
      </div>
    </section>
  );
}